// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Formatting = t.struct({
    dateFields: t.list(t.String)
});

export const getDefaultState = () =>
    new Formatting({
        dateFields: [
            'estimatedBasicDate',
            'invoiceDate',
            'reportDate'
        ]
    });

export default Formatting;



// WEBPACK FOOTER //
// ./src/reports/basic-warranty-estimator/state/formatting.js